'use server';

import request from '../../../../api/request';
import { actionKitImpFunction } from '../../../../components/ozmoit/common';
import { Collection } from '../../interfaces/collection';
import { GenerateSalenoteParams } from '../types';

const getNonSaleNotesCollectionsAction = actionKitImpFunction(async () => {
  const response = await request<Collection[]>(
    'maintainers-portal/payment-hub/non-salenotes/list',
  );
  if (response.error) {
    throw new Error('Error fetching non-sale notes collections data');
  }
  return response.data;
});

const generateSalenote = actionKitImpFunction(
  async ({ collectionId, ...data }: GenerateSalenoteParams) => {
    const response = await request(
      `maintainers-portal/payment-hub/non-salenotes/create/${collectionId}`,
      { method: 'POST', data },
    );
    if (response.error) {
      throw new Error(
        response.error?.data?.message || 'Error registering payment',
      );
    }
    return response.data;
  },
);

export { getNonSaleNotesCollectionsAction, generateSalenote };
